<template>
  <BarChartCard
    :chartHeight="300"
    :title="title"
    :chartData="gasFuelDieselConsumptionChart.data"
    :options="gasFuelDieselConsumptionChart.options"
    :loading="loadingGasFuelDieselConsumptionData"
    info-text="This card shows how many trees does it take to offset your annual footprint"
  >
    <div slot="dropdown">
      <multiselect
        v-model="selectedYear"
        :options="years"
        :multiple="false"
        :close-on-select="true"
        :allowEmpty="false"
        @select="selectYear($event)"
        :show-labels="false"
        placeholder="Select Year"
      >
      </multiselect>
    </div>
  </BarChartCard>
</template>

<script>
import BarChartCard from '@/components/Cards/BarChartCard';
import CategoryConsumptionStatsController from '@/controllers/Consumption/CategoryConsumptionStatsController';
import TotalGasAndFuelConsumptionController from '@/controllers/Consumption/TotalGasAndFuelConsumptionController';
export default {
  name: 'CompareFuelDieselGasConsumptions',
  components: { BarChartCard },
  props: {
    consumption_category_id: Number,
    title: String,
  },
  data() {
    return {
      years: [this.getCurrentYear(), this.getCurrentYear() - 1, this.getCurrentYear() - 2],
      selectedYear: this.getCurrentYear(),
      loadingGasFuelDieselConsumptionData: false,
      gasFuelDieselConsumptionData: false,
      gasFuelDieselConsumptionChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          datasets: [
            {
              label: 'Gas (Gal.)',
              data: [300000, 310000, 290000, 270000, 280000, 320000, 300000, 310000, 290000, 270500, 280000, 320000],
              borderColor: '#73AB6B',
              backgroundColor: '#73AB6B',
              type: 'line',
              fill: false,
              order: 1,
            },
            {
              label: 'Fuel (Gal.)',
              data: [290000, 230000, 260000, 300000, 310000, 320000, 290000, 270000, 280000, 260500, 270000, 250000],
              borderColor: '#FFC105',
              backgroundColor: '#FFC105',
              type: 'line',
              fill: false,
              order: 2,
            },
            {
              label: 'Diesel (Gal.)',
              data: [270000, 250000, 270000, 320000, 270000, 334000, 270000, 280000, 240000, 230500, 220000, 210000],
              borderColor: '#DC3544',
              backgroundColor: '#DC3544',
              type: 'line',
              fill: false,
              order: 3,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          animation: false,
          showAllTooltips: false,
          legend: {
            display: true,
          },
          plugins: {
            title: {
              display: true,
              text: 'Chart.js Doughnut Chart',
            },
          },
        },
      },
    };
  },
  created() {
    this.loadGasFuelDieselConsumptionData(this.selectedYear);
  },
  methods: {
    async loadGasFuelDieselConsumptionData(year) {
      this.loadingGasFuelDieselConsumptionData = true;
      this.gasFuelDieselConsumptionData = await TotalGasAndFuelConsumptionController.index(year);
      this.updateGasFuelDieselConsumptionDataChart();
      this.loadingGasFuelDieselConsumptionData = false;
    },
    updateGasFuelDieselConsumptionDataChart() {
      this.gasFuelDieselConsumptionChart = Object.assign({}, this.gasFuelDieselConsumptionChart, {
        data: {
          labels: this.gasFuelDieselConsumptionData.labels,
          datasets: [
            {
              label: 'Gas (Gal.)',
              data: this.gasFuelDieselConsumptionData.series[0],
              borderColor: '#73AB6B',
              backgroundColor: '#73AB6B',
              type: 'line',
              fill: false,
              order: 1,
            },
            {
              label: 'Fuel (Gal.)',
              data: this.gasFuelDieselConsumptionData.series[1],
              borderColor: '#FFC105',
              backgroundColor: '#FFC105',
              type: 'line',
              fill: false,
              order: 2,
            },
            {
              label: 'Diesel (Gal.)',
              data: this.gasFuelDieselConsumptionData.series[2],
              borderColor: '#DC3544',
              backgroundColor: '#DC3544',
              type: 'line',
              fill: false,
              order: 3,
            },
          ],
        },
      });
    },
    getCurrentYear() {
      return new Date().getFullYear();
    },
    selectYear(year) {
      this.loadGasFuelDieselConsumptionData(year);
    },
  },
};
</script>

<style scoped></style>
